import { Rarity } from '@sorare/core/src/__generated__/globalTypes';

export const cardCountsToRarities = (counts: {
  limited: number;
  rare: number;
  super_rare: number;
  unique: number;
  common?: number;
  custom_series?: number;
}) => {
  const totalBlockchainCards =
    counts.limited + counts.rare + counts.super_rare + counts.unique;

  return [
    counts.limited && Rarity.limited,
    counts.rare && Rarity.rare,
    counts.super_rare && Rarity.super_rare,
    counts.unique && Rarity.unique,
    counts.custom_series && Rarity.custom_series,
    !totalBlockchainCards && counts.common && Rarity.common,
  ].filter(Boolean);
};
